const HeartFull = ({
  fill = "#fff",
  stroke = "#fff",
  strokeWidth = "1",
  width = "20",
  height = "18",
  ...props
}: {
  fill?: string;
  stroke?: string;
  strokeWidth?: string;
  width?: string;
  height?: string;
}): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 18"
    {...props}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      stroke={stroke}
      strokeWidth={strokeWidth}
      d="M14.5 1a4.497 4.497 0 00-3.683 1.913 4.524 4.524 0 00-.818 2.333 4.518 4.518 0 00-.817-2.334A4.496 4.496 0 005.5 1a4.307 4.307 0 00-3.2 1.398C1.486 3.283 1 4.528 1 5.981c0 3.667 3.14 7.235 9 10.848 5.877-3.624 9-7.217 9-11.329a4.486 4.486 0 00-1.318-3.182A4.488 4.488 0 0014.5 1z"
    />
  </svg>
);

export { HeartFull };
